import { MutationTree } from "vuex";
import {
  GroupedFlightsMap,
  IQuotationManagementState,
  SurchargeDataWithAirlineCode,
  UpdatedFareOptions,
} from "@/core/interfaces/state/quotationManagmentState.interface";
import notificationService from "@/core/services/notification.service";
import { NOTIFICATION_TYPES } from "@/core/enums/NOTIFICATION_TYPES";

const mutations: MutationTree<IQuotationManagementState> = {
  saveGroupFlightsByAirline(state, payload: GroupedFlightsMap | null) {
    state.groupedQuotesByAirlineMap = payload;
  },

  addSurcharge(state, payload: SurchargeDataWithAirlineCode) {
    state.surcharges = state.surcharges.filter(
      (s) => s.airlineCode !== payload.airlineCode,
    );

    state.surcharges.push(payload);
  },

  saveUpdatedFareOptions(state, payload: UpdatedFareOptions) {
    state.updatedFareOptions = payload;
  },

  triggerQuotationRender(state) {
    state.quotationRenderTrigger = !state.quotationRenderTrigger;
  },

  clearSurcharge(state, airlineCode: string) {
    let hadSurcharge = false;
    state.surcharges = state.surcharges.filter((s) => {
      if (s.airlineCode === airlineCode) {
        hadSurcharge = true;
      }
      return s.airlineCode !== airlineCode;
    });

    if (hadSurcharge) {
      notificationService.type = NOTIFICATION_TYPES.INFO;
      notificationService.description = `Surcharges cleared for ${airlineCode}`;
      notificationService.triggerNotification();
    }
  },

  clearAllSurcharges(state) {
    if (!(state.surcharges.length > 0)) {
      return;
    }
    state.surcharges = [];
    state.updatedFareOptions = null;
    notificationService.type = NOTIFICATION_TYPES.INFO;
    notificationService.description = `All surcharges cleared.`;
    notificationService.triggerNotification();
  },

  setIsApplySurchargePending(state, value: boolean) {
    state.isApplySurchargePending = value;
  },
  setIsClearAllSurchargesPending(state, value: boolean) {
    state.isClearAllSurchargesPending = value;
  },
};

export default mutations;
